








import { Component, Vue } from 'vue-property-decorator';
import { TransceiversApi } from '@/api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

@Component({
	components: {},
	props: {
		transceiverId: Number,
	},
})
export default class TransceiverReceivedTsChartSeries extends Vue {
	public graph;
	public transceiverId;
	public chart;
	public series = 'receivedTS';
	public nDays;

	public mounted() {
		this.graphData();
	}

	public async graphData() {
		try {
			const { data } = await new TransceiversApi().getTransceiverData(
				parseInt(this.transceiverId, 10),
				{ params: { limit: 200 } },
			);
			this.graph = data.data.reverse();
			this.graph.forEach(item => {
				item.diff =
					Math.round(new Date(item.receivedTS * 1000) - new Date(item.data.timestamp * 1000)) /
					1000 /
					60;
				item.diffString = Math.round(item.diff).toLocaleString() + 'm';
				item.receivedTSString = this.$options.filters.shortDateTime(
					new Date(item.receivedTS * 1000),
				);
			});
			this.loadChart();
		} catch (e) {
			console.log(e);
		} finally {
			// console.log('done');
		}
	}

	public async loadChart() {
		// am4core.disposeAllCharts();

		am4core.useTheme(am4themes_animated);
		this.chart = am4core.create('chartdiv' + this.transceiverId + this.series, am4charts.XYChart);
		// Increase contrast by taking evey second color
		this.chart.colors.step = 2;
		// Create axes
		const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.renderer.minGridDistance = 50;
		dateAxis.baseInterval = { timeUnit: 'days' };
		this.chart.scrollbarX = new am4core.Scrollbar();
		this.chart.scrollbarY = new am4core.Scrollbar();

		this.chart.cursor = new am4charts.XYCursor();
		this.chart.cursor.behavior = 'zoomXY';

		const hasDifLargerThan60 = this.graph.find(val => val.diff > 60);

		this.createAxisAndSeries(
			'receivedTS',
			'receivedTSString',
			'Received Timestamp',
			true,
			'circle',
		);
		this.createAxisAndSeries(
			'diff',
			'diffString',
			'Difference (Minutes)',
			false,
			'circle',
			hasDifLargerThan60 ? undefined : 60,
		);
		// this.createAxisAndSeries('date', 'Date Generated', true, 'circle')

		// Add legend and cursor
		this.chart.legend = new am4charts.Legend();
	}

	// Create series
	public createAxisAndSeries(field, valueField, name, opposite, shape, minYScale) {
		const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		const series = this.chart.series.push(new am4charts.XYSeries());
		series.dataFields.valueY = field;
		series.dataFields.dateX = 'date';
		series.strokeWidth = 2;
		series.yAxis = valueAxis;
		series.name = name;

		valueAxis.max = minYScale;
		// series.tooltipHTML  = `{name} ({valueY})`
		// series.tensionX = 0.8

		const chartData = [];
		this.graph.forEach(row => {
			let payload = '';
			const dataPayload = JSON.stringify(row.data);
			let j = 0;
			for (const key in dataPayload) {
				if (dataPayload.hasOwnProperty(key)) {
					payload += dataPayload[key];
					if (j > 70) {
						j = 0;
						payload += '\n';
					}
					j++;
				}
			}
			const details = `Topic: ${row.topic}
                       ${payload}`;
			chartData.push({
				size: 3,
				date: new Date(row.data.timestamp * 1000),
				[field]: row[field],
				value: row[valueField],
				details: field === 'receivedTS' ? details : '',
			});
		});
		series.data = chartData;

		const interfaceColors = new am4core.InterfaceColorSet();

		const bullet = series.bullets.push(new am4charts.CircleBullet());
		// // bullet.circle.fill = am4core.color('#fff');
		// // bullet.circle.strokeWidth = 1;
		// // bullet.circle.propertyFields.radius = 'size';
		// // bullet.circle.propertyFields.fill = 'fill';
		//
		// // var bullet = series.bullets.push(new am4core.Circle());
		bullet.strokeWidth = 1;
		bullet.fillOpacity = 0.5;
		// bullet.hiddenState.properties.opacity = 0;
		bullet.circle.propertyFields.radius = 'size';
		bullet.circle.propertyFields.fill = 'fill';
		bullet.tooltipText = '{name}: {value}\n{details}';

		valueAxis.renderer.line.strokeOpacity = 1;
		valueAxis.renderer.line.strokeWidth = 2;
		valueAxis.renderer.line.stroke = series.stroke;
		valueAxis.renderer.labels.template.fill = series.stroke;
		valueAxis.renderer.opposite = opposite;
		valueAxis.renderer.grid.template.disabled = true;
	}
}
